import { render, staticRenderFns } from "./Banner.vue?vue&type=template&id=1ca1194a&scoped=true&"
import script from "./Banner.vue?vue&type=script&lang=js&"
export * from "./Banner.vue?vue&type=script&lang=js&"
import style0 from "./Banner.vue?vue&type=style&index=0&id=1ca1194a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca1194a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oh/Projects/php_was2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ca1194a')) {
      api.createRecord('1ca1194a', component.options)
    } else {
      api.reload('1ca1194a', component.options)
    }
    module.hot.accept("./Banner.vue?vue&type=template&id=1ca1194a&scoped=true&", function () {
      api.rerender('1ca1194a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Setting/Banner.vue"
export default component.exports